import {
  AgentSetupBlock,
  type AgentSetupBlockProps,
  AgentSetupCompleteBlock,
  FeatureLabel,
} from 'hooks/dialogs/cluster/components/features';

type SetupProps = Pick<AgentSetupBlockProps, 'checked' | 'onChange'>;

type CompleteProps = {
  checked?: boolean;
};

const heading = 'Vulnerability detection';

export const SecurityVulnerabilityDetectionSetup = (props: SetupProps) => {
  return (
    <AgentSetupBlock
      heading={heading}
      description="Identify vulnerabilities in the container images running in the cluster and receive recommendations on how to address them."
      checked={props.checked}
      onChange={props.onChange}
      labelChip={<FeatureLabel type="free" />}
      testId="security-vulnerability-detection"
    />
  );
};

export const SecurityVulnerabilityDetectionComplete = ({
  checked,
}: CompleteProps) => {
  return (
    <AgentSetupCompleteBlock
      heading={heading}
      testId="security-vulnerability-detection-complete"
      checked={checked}
    />
  );
};
